var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return (_vm.isDriblab && _vm.currentUser.showMediaMode) || !_vm.isDriblab
    ? _c(
        "v-card",
        { staticClass: "mb-2", attrs: { elevation: "0", outlined: "" } },
        [
          _c("v-card-title", { staticClass: "pa-2 body-1" }, [
            _c(
              "div",
              {
                staticClass: "d-flex justify-space-between w-100 align-center",
              },
              [
                _c("span", { staticClass: "body-1 primary--text" }, [
                  _vm._v(_vm._s(_vm.$t("general.mediaMode"))),
                ]),
                _vm._v(" "),
                _c("v-switch", {
                  staticClass: "mt-n1",
                  attrs: { color: "secondary", label: "", "hide-details": "" },
                  on: {
                    change: function ($event) {
                      return _vm.onMediaModeChange()
                    },
                  },
                  model: {
                    value: _vm._mediaMode,
                    callback: function ($$v) {
                      _vm._mediaMode = $$v
                    },
                    expression: "_mediaMode",
                  },
                }),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("v-divider"),
          _vm._v(" "),
          _vm._mediaMode && !_vm.selectorMode
            ? _c(
                "v-card-text",
                {
                  staticClass:
                    "py-0 px-0 d-flex flex-column flex-wrap align-start justify-space-between",
                  staticStyle: { overflow: "auto" },
                },
                _vm._l(_vm.fields, function (field, index) {
                  return _c(
                    "div",
                    {
                      key: index,
                      class: `d-flex flex-column w-${_vm.fieldSize}`,
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "d-flex flex-column px-2 py-1" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "d-flex justify-space-between align-center cursor-pointer",
                              on: {
                                click: function ($event) {
                                  _vm._mediaModeFlags[field.key] =
                                    !_vm._mediaModeFlags[field.key]
                                },
                              },
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  _vm._s(_vm.$t(field.label, field.labelParams))
                                ),
                              ]),
                              _vm._v(" "),
                              field.type != "switch"
                                ? _c("v-icon", [
                                    _vm._v(
                                      _vm._s(
                                        _vm._mediaModeFlags[field.key]
                                          ? "arrow_drop_up"
                                          : "arrow_drop_down"
                                      )
                                    ),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              field.type === "switch"
                                ? _c("v-switch", {
                                    staticClass: "mt-n1",
                                    attrs: {
                                      color: "secondary",
                                      label: "",
                                      "hide-details": "",
                                      dense: "",
                                    },
                                    model: {
                                      value: _vm._mediaModeData[field.key],
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm._mediaModeData,
                                          field.key,
                                          $$v
                                        )
                                      },
                                      expression: "_mediaModeData[field.key]",
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("v-expand-transition", [
                            field.type === "text"
                              ? _c(
                                  "div",
                                  { staticClass: "d-flex justify-center" },
                                  [
                                    _c("v-text-field", {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm._mediaModeFlags[field.key],
                                          expression:
                                            "_mediaModeFlags[field.key]",
                                        },
                                      ],
                                      staticClass: "py-0 slim-input",
                                      attrs: {
                                        dense: "",
                                        outlined: "",
                                        "hide-details": "",
                                      },
                                      on: {
                                        keydown: function ($event) {
                                          if (
                                            !$event.type.indexOf("key") &&
                                            _vm._k(
                                              $event.keyCode,
                                              "enter",
                                              13,
                                              $event.key,
                                              "Enter"
                                            )
                                          )
                                            return null
                                          return _vm.onMediaControlsChange()
                                        },
                                        blur: function ($event) {
                                          return _vm.onMediaControlsChange()
                                        },
                                      },
                                      model: {
                                        value: _vm._mediaModeData[field.key],
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm._mediaModeData,
                                            field.key,
                                            $$v
                                          )
                                        },
                                        expression: "_mediaModeData[field.key]",
                                      },
                                    }),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            field.type === "number"
                              ? _c(
                                  "div",
                                  { staticClass: "d-flex justify-center" },
                                  [
                                    _c("v-text-field", {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm._mediaModeFlags[field.key],
                                          expression:
                                            "_mediaModeFlags[field.key]",
                                        },
                                      ],
                                      staticClass: "py-0 slim-input",
                                      attrs: {
                                        dense: "",
                                        outlined: "",
                                        "hide-details": "",
                                        type: "number",
                                      },
                                      on: {
                                        keydown: function ($event) {
                                          if (
                                            !$event.type.indexOf("key") &&
                                            _vm._k(
                                              $event.keyCode,
                                              "enter",
                                              13,
                                              $event.key,
                                              "Enter"
                                            )
                                          )
                                            return null
                                          return _vm.onMediaControlsChange()
                                        },
                                        blur: function ($event) {
                                          return _vm.onMediaControlsChange()
                                        },
                                      },
                                      model: {
                                        value: _vm._mediaModeData[field.key],
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm._mediaModeData,
                                            field.key,
                                            $$v
                                          )
                                        },
                                        expression: "_mediaModeData[field.key]",
                                      },
                                    }),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            field.type === "color"
                              ? _c(
                                  "div",
                                  { staticClass: "d-flex justify-center" },
                                  [
                                    _c("v-color-picker", {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm._mediaModeFlags[field.key],
                                          expression:
                                            "_mediaModeFlags[field.key]",
                                        },
                                      ],
                                      staticClass: "py-0",
                                      attrs: {
                                        "dot-size": "25",
                                        mode: "hexa",
                                        "canvas-height": "75",
                                        "hide-inputs": false,
                                      },
                                      on: {
                                        "update:color": function ($event) {
                                          return _vm.onMediaControlsChange()
                                        },
                                      },
                                      model: {
                                        value: _vm._mediaModeData[field.key],
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm._mediaModeData,
                                            field.key,
                                            $$v
                                          )
                                        },
                                        expression: "_mediaModeData[field.key]",
                                      },
                                    }),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            field.type === "radio"
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "d-flex justify-center w-100",
                                  },
                                  [
                                    _c(
                                      "v-radio-group",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value:
                                              _vm._mediaModeFlags[field.key],
                                            expression:
                                              "_mediaModeFlags[field.key]",
                                          },
                                        ],
                                        staticClass: "my-1",
                                        attrs: {
                                          "hide-details": "",
                                          mandatory: "",
                                          row: "",
                                        },
                                        on: {
                                          change: function ($event) {
                                            return _vm.onMediaControlsChange()
                                          },
                                        },
                                        model: {
                                          value: _vm._mediaModeData[field.key],
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm._mediaModeData,
                                              field.key,
                                              $$v
                                            )
                                          },
                                          expression:
                                            "_mediaModeData[field.key]",
                                        },
                                      },
                                      _vm._l(
                                        field.options,
                                        function (option, index) {
                                          return _c("v-radio", {
                                            key: index,
                                            attrs: {
                                              color: "secondary",
                                              label: _vm.$t(option.label),
                                              value: option.value,
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "label",
                                                  fn: function () {
                                                    return [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "body-1 primary--text",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                option.label
                                                              )
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  },
                                                  proxy: true,
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                          })
                                        }
                                      ),
                                      1
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            field.type === "image"
                              ? _c(
                                  "div",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm._mediaModeFlags[field.key],
                                        expression:
                                          "_mediaModeFlags[field.key]",
                                      },
                                    ],
                                    staticClass: "d-flex flex-column w-100",
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "file-selector w-100 mb-5",
                                      },
                                      [
                                        _c("v-file-input", {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value:
                                                _vm._mediaModeFlags[field.key],
                                              expression:
                                                "_mediaModeFlags[field.key]",
                                            },
                                          ],
                                          attrs: {
                                            "prepend-icon": "",
                                            "prepend-inner-icon": "$file",
                                            "hide-details": "",
                                            flat: "",
                                            solo: "",
                                            dense: "",
                                            height: "25px",
                                            placeholder:
                                              _vm.$t("general.uploadFile"),
                                          },
                                          on: {
                                            change: function ($event) {
                                              return _vm.onFileChange(
                                                $event,
                                                field
                                              )
                                            },
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    field.type === "image" &&
                                    _vm._mediaModeData[field.key].src &&
                                    _vm._mediaModeFlags[field.key]
                                      ? _c("cropper", {
                                          ref: "cropper",
                                          refInFor: true,
                                          staticStyle: { height: "320px" },
                                          attrs: {
                                            src: _vm._mediaModeData[field.key]
                                              .src,
                                            defaultPosition:
                                              _vm._mediaModeData[field.key]
                                                .defaultPosition,
                                            defaultSize:
                                              _vm._mediaModeData[field.key]
                                                .defaultSize,
                                            debounce: 100,
                                            "stencil-size": {
                                              width: 300,
                                              height: 300,
                                            },
                                            "stencil-props": {
                                              aspectRatio: 1,
                                              movable: false,
                                              resizable: false,
                                              handlers: {},
                                            },
                                            imageRestriction: "stencil",
                                            defaultBoundaries: "fill",
                                          },
                                          on: {
                                            change: function ($event) {
                                              return _vm.onCropperChange(
                                                $event,
                                                field
                                              )
                                            },
                                          },
                                        })
                                      : _vm._e(),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("v-divider"),
                    ],
                    1
                  )
                }),
                0
              )
            : _vm._e(),
          _vm._v(" "),
          _vm._mediaMode && _vm.selectorMode
            ? _c(
                "v-card-text",
                {
                  staticClass:
                    "py-0 px-0 d-flex flex-column flex-wrap align-start justify-space-between",
                  staticStyle: { overflow: "auto" },
                },
                [
                  _c(
                    "div",
                    { staticClass: "d-flex w-100 pa-2 mb-2" },
                    [
                      _c("v-autocomplete", {
                        staticClass:
                          "slim-input body-1 primary--text font-weight-bold",
                        attrs: {
                          items: _vm.fields,
                          "return-object": "",
                          dense: "",
                          "hide-details": "",
                          "item-value": "key",
                          color: "secondary",
                          placeholder: _vm.$t("mediaMode.selectField"),
                          filled: "",
                          "auto-select-first": "",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "selection",
                              fn: function ({ item }) {
                                return [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(item.label, item.labelParams)
                                      )
                                    ),
                                  ]),
                                ]
                              },
                            },
                            {
                              key: "item",
                              fn: function ({ item }) {
                                return [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(item.label, item.labelParams)
                                      )
                                    ),
                                  ]),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          2039747644
                        ),
                        model: {
                          value: _vm.selectedField,
                          callback: function ($$v) {
                            _vm.selectedField = $$v
                          },
                          expression: "selectedField",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.selectedField
                    ? _c("div", { staticClass: "d-flex px-2 pb-2 w-100" }, [
                        _vm.selectedField.type === "switch"
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "d-flex justify-center align-center w-100",
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "mr-2 v-label cursor-pointer primary--text body-1",
                                    on: {
                                      click: function ($event) {
                                        _vm._mediaModeData[
                                          _vm.selectedField.key
                                        ] =
                                          !_vm._mediaModeData[
                                            _vm.selectedField.key
                                          ]
                                        _vm.onMediaControlsChange()
                                      },
                                    },
                                  },
                                  [_vm._v(_vm._s(_vm.$t("general.disabled")))]
                                ),
                                _vm._v(" "),
                                _c("v-switch", {
                                  staticClass: "mt-n1",
                                  attrs: {
                                    color: "secondary",
                                    label: _vm.$t("general.enabled"),
                                    "hide-details": "",
                                    dense: "",
                                  },
                                  on: {
                                    change: function ($event) {
                                      return _vm.onMediaControlsChange()
                                    },
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "label",
                                        fn: function () {
                                          return [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "body-1 primary--text",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t("general.enabled")
                                                  )
                                                ),
                                              ]
                                            ),
                                          ]
                                        },
                                        proxy: true,
                                      },
                                    ],
                                    null,
                                    false,
                                    2499626746
                                  ),
                                  model: {
                                    value:
                                      _vm._mediaModeData[_vm.selectedField.key],
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm._mediaModeData,
                                        _vm.selectedField.key,
                                        $$v
                                      )
                                    },
                                    expression:
                                      "_mediaModeData[selectedField.key]",
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.selectedField.type === "text"
                          ? _c(
                              "div",
                              { staticClass: "d-flex justify-center" },
                              [
                                _c("v-text-field", {
                                  staticClass: "py-0 slim-input",
                                  attrs: {
                                    dense: "",
                                    outlined: "",
                                    "hide-details": "",
                                  },
                                  on: {
                                    keydown: function ($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      )
                                        return null
                                      return _vm.onMediaControlsChange()
                                    },
                                    blur: function ($event) {
                                      return _vm.onMediaControlsChange()
                                    },
                                  },
                                  model: {
                                    value:
                                      _vm._mediaModeData[_vm.selectedField.key],
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm._mediaModeData,
                                        _vm.selectedField.key,
                                        $$v
                                      )
                                    },
                                    expression:
                                      "_mediaModeData[selectedField.key]",
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.selectedField.type === "number"
                          ? _c(
                              "div",
                              { staticClass: "d-flex justify-center" },
                              [
                                _c("v-text-field", {
                                  staticClass: "py-0 slim-input",
                                  attrs: {
                                    dense: "",
                                    outlined: "",
                                    "hide-details": "",
                                    type: "number",
                                  },
                                  on: {
                                    keydown: function ($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      )
                                        return null
                                      return _vm.onMediaControlsChange()
                                    },
                                    blur: function ($event) {
                                      return _vm.onMediaControlsChange()
                                    },
                                  },
                                  model: {
                                    value:
                                      _vm._mediaModeData[_vm.selectedField.key],
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm._mediaModeData,
                                        _vm.selectedField.key,
                                        $$v
                                      )
                                    },
                                    expression:
                                      "_mediaModeData[selectedField.key]",
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.selectedField.type === "color"
                          ? _c(
                              "div",
                              { staticClass: "d-flex justify-center w-100" },
                              [
                                _c("v-color-picker", {
                                  staticClass: "py-0",
                                  attrs: {
                                    "dot-size": "25",
                                    mode: "hexa",
                                    "canvas-height": "75",
                                    "hide-inputs": false,
                                  },
                                  on: {
                                    "update:color": function ($event) {
                                      return _vm.onMediaControlsChange()
                                    },
                                  },
                                  model: {
                                    value:
                                      _vm._mediaModeData[_vm.selectedField.key],
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm._mediaModeData,
                                        _vm.selectedField.key,
                                        $$v
                                      )
                                    },
                                    expression:
                                      "_mediaModeData[selectedField.key]",
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.selectedField.type === "radio"
                          ? _c(
                              "div",
                              { staticClass: "d-flex justify-center w-100" },
                              [
                                _c(
                                  "v-radio-group",
                                  {
                                    staticClass: "my-1",
                                    attrs: {
                                      "hide-details": "",
                                      mandatory: "",
                                      row: "",
                                    },
                                    on: {
                                      change: function ($event) {
                                        return _vm.onMediaControlsChange()
                                      },
                                    },
                                    model: {
                                      value:
                                        _vm._mediaModeData[
                                          _vm.selectedField.key
                                        ],
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm._mediaModeData,
                                          _vm.selectedField.key,
                                          $$v
                                        )
                                      },
                                      expression:
                                        "_mediaModeData[selectedField.key]",
                                    },
                                  },
                                  _vm._l(
                                    _vm.selectedField.options,
                                    function (option, index) {
                                      return _c("v-radio", {
                                        key: index,
                                        attrs: {
                                          color: "secondary",
                                          label: _vm.$t(option.label),
                                          value: option.value,
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "label",
                                              fn: function () {
                                                return [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "body-1 primary--text",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(option.label)
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              },
                                              proxy: true,
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      })
                                    }
                                  ),
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.selectedField.type === "select-multiple"
                          ? _c(
                              "div",
                              { staticClass: "d-flex justify-center w-100" },
                              [
                                _c("v-select", {
                                  staticClass: "my-1 slim-input",
                                  attrs: {
                                    "hide-details": "",
                                    multiple: "",
                                    outlined: "",
                                    items: _vm.selectedField.options,
                                  },
                                  on: {
                                    change: function ($event) {
                                      return _vm.onMediaControlsChange()
                                    },
                                  },
                                  model: {
                                    value:
                                      _vm._mediaModeData[_vm.selectedField.key],
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm._mediaModeData,
                                        _vm.selectedField.key,
                                        $$v
                                      )
                                    },
                                    expression:
                                      "_mediaModeData[selectedField.key]",
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.selectedField.type === "select"
                          ? _c(
                              "div",
                              { staticClass: "d-flex justify-center w-100" },
                              [
                                _c("v-autocomplete", {
                                  staticClass: "my-1 slim-input",
                                  attrs: {
                                    "hide-details": "",
                                    outlined: "",
                                    "item-text": _vm.selectedField.itemText,
                                    "item-value": _vm.selectedField.itemValue,
                                    "return-object":
                                      _vm.selectedField.returnObject,
                                    items: _vm.selectedField.options,
                                    placeholder: _vm.$t(
                                      _vm.selectedField.placeholder
                                    ),
                                  },
                                  on: {
                                    change: function ($event) {
                                      return _vm.onMediaControlsChange()
                                    },
                                  },
                                  model: {
                                    value:
                                      _vm._mediaModeData[_vm.selectedField.key],
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm._mediaModeData,
                                        _vm.selectedField.key,
                                        $$v
                                      )
                                    },
                                    expression:
                                      "_mediaModeData[selectedField.key]",
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.selectedField.type === "image"
                          ? _c(
                              "div",
                              { staticClass: "d-flex flex-column w-100" },
                              [
                                _c(
                                  "div",
                                  { staticClass: "file-selector w-100 mb-5" },
                                  [
                                    _c("v-file-input", {
                                      attrs: {
                                        "prepend-icon": "",
                                        "prepend-inner-icon": "$file",
                                        "hide-details": "",
                                        flat: "",
                                        solo: "",
                                        dense: "",
                                        height: "25px",
                                        placeholder:
                                          _vm.$t("general.uploadFile"),
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.onFileChange(
                                            $event,
                                            _vm.selectedField
                                          )
                                        },
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _vm.selectedField.type === "image" &&
                                _vm._mediaModeData[_vm.selectedField.key].src
                                  ? _c("cropper", {
                                      ref: "cropper",
                                      staticStyle: { height: "320px" },
                                      attrs: {
                                        src: _vm._mediaModeData[
                                          _vm.selectedField.key
                                        ].src,
                                        defaultPosition:
                                          _vm._mediaModeData[
                                            _vm.selectedField.key
                                          ].defaultPosition,
                                        defaultSize:
                                          _vm._mediaModeData[
                                            _vm.selectedField.key
                                          ].defaultSize,
                                        debounce: 100,
                                        "stencil-size": _vm.selectedField
                                          .stencilSize
                                          ? null
                                          : {
                                              width: 300,
                                              height: 300,
                                            },
                                        "stencil-props": {
                                          aspectRatio:
                                            _vm.selectedField.aspectRatio || 1,
                                          movable: false,
                                          resizable:
                                            _vm.selectedField.resizable ||
                                            false,
                                          handlers: {},
                                        },
                                        imageRestriction:
                                          _vm.selectedField.imageRestriction ||
                                          "stencil",
                                        defaultBoundaries: "fill",
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.onCropperChange(
                                            $event,
                                            _vm.selectedField
                                          )
                                        },
                                        error: function ($event) {
                                          return _vm.onCropperError(
                                            $event,
                                            _vm.selectedField
                                          )
                                        },
                                      },
                                    })
                                  : _vm._e(),
                              ],
                              1
                            )
                          : _vm._e(),
                      ])
                    : _vm._e(),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm._mediaMode && _vm.showButtons ? _c("v-divider") : _vm._e(),
          _vm._v(" "),
          _vm._mediaMode && _vm.showButtons
            ? _c(
                "v-card-actions",
                { staticClass: "d-flex justify-end pt-2 mt-0" },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass:
                        "elevation-0 monospace-font white--text px-3 mx-1",
                      attrs: {
                        color: "secondary",
                        rounded: "",
                        small: "",
                        "x-small": !_vm.$vuetify.breakpoint.xsOnly,
                      },
                      nativeOn: {
                        click: function ($event) {
                          return _vm.saveAsPNG()
                        },
                      },
                    },
                    [
                      _c(
                        "v-icon",
                        { staticClass: "mr-1", attrs: { small: "" } },
                        [_vm._v("\n        file_download")]
                      ),
                      _vm._v(" "),
                      _c("span", {}, [_vm._v("PNG")]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      staticClass:
                        "elevation-0 monospace-font white--text px-3 mx-1",
                      attrs: {
                        color: "secondary",
                        rounded: "",
                        small: "",
                        "x-small": !_vm.$vuetify.breakpoint.xsOnly,
                      },
                      nativeOn: {
                        click: function ($event) {
                          return _vm.saveAsSVG()
                        },
                      },
                    },
                    [
                      _c("v-icon", { attrs: { small: "" } }, [
                        _vm._v("file_download"),
                      ]),
                      _vm._v(" "),
                      _c("span", [_vm._v("SVG")]),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }